import { IOption } from 'components/input/selectInput';
import { FmlxTextBox, FmlxTextInput } from 'fmlx-common-ui';
import React from 'react';

type NumberSelectControlProps = {
  className?: string;
  options?: IOption[];
  value: number;
  setValue: (value: number) => void;
  unit: string | number;
  setUnit: (unit: string | number) => void;
  disabled?: boolean;
};

export default function NumberSelectControl(props: NumberSelectControlProps) {
  const {
    className = '',
    options = [],
    value,
    setValue,
    unit,
    setUnit,
    disabled,
  } = props;

  return (
    <div
      className={`${className} inline-flex items-center border border-[#B4B4B4] rounded-sm bg-[#F5F5F5] overflow-hidden text-sm`}
    >
      {/* Number Input */}
      <FmlxTextBox
        mode="number"
        variant={FmlxTextInput.Variant.STANDARD}
        onChange={(val) => setValue(parseInt(val.value) || 0)}
        minValue={1}
        value={value}
        disabled={disabled}
        textAlign={FmlxTextInput.TextAlign.CENTER}
      />

      {/* Divider */}
      <div className="w-px h-7 bg-[#B4B4B4]" />

      {/* Select Dropdown */}
      <div className="relative flex items-center">
        <select
          disabled={disabled}
          value={unit}
          onChange={(e) => setUnit(e.target.value)}
          className="pl-2 pr-6 py-1 bg-transparent outline-none appearance-none cursor-pointer border-none"
        >
          {options.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.title}
            </option>
          ))}
        </select>

        {/* Arrow */}
        <span className="absolute right-1 inset-y-0 flex items-center text-xs text-gray-600 pointer-events-none">
          ▼
        </span>
      </div>
    </div>
  );
}
